import { Provider } from 'react-redux';
import AppRouter from './presentation/router/AppRouter';
import { store } from './presentation/store';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { initGA } from './config/plugins/GoogleAnalytics';
import { useEffect } from 'react';
import { initGTM } from './config/plugins/TagManager';

// Crea una nueva instancia del QueryClient
const queryClient = new QueryClient();

function App() {
  useEffect(() => {
    initGA();
    initGTM();
  }, []);

  return (
    <>
      <Provider store={store}>
        <BrowserRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <QueryClientProvider client={queryClient}>
            <AppRouter />
          </QueryClientProvider>
        </BrowserRouter>
      </Provider>
    </>
  );
}

export default App;
